
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { VenueCard } from "./VenueCard";
import { useVenueShortlist } from "@/hooks/use-venue-shortlist";

interface ShortlistedVenueCarouselProps {
  eventId: string;
}

export const ShortlistedVenueCarousel = ({
  eventId
}: ShortlistedVenueCarouselProps) => {
  const {
    shortlistedVenues = [],
    removeFromShortlist,
    isProcessing
  } = useVenueShortlist(eventId);

  if (!shortlistedVenues.length) {
    return null;
  }

  return (
    <div className="w-full mb-8">
      <h3 className="font-semibold mb-4">Your Shortlisted Venues</h3>
      <Carousel className="w-full" opts={{
        align: 'start',
        containScroll: 'trimSnaps'
      }}>
        <CarouselContent className="-ml-2 md:-ml-4">
          {shortlistedVenues.map(venue => (
            <CarouselItem key={venue.venue_id} className="pl-2 md:pl-4 basis-4/5 sm:basis-3/4 md:basis-3/5 lg:basis-2/5">
              <VenueCard 
                venue={venue} 
                isInShortlist={true} 
                onToggleShortlist={() => removeFromShortlist(venue.venue_id as string)} 
                isProcessing={isProcessing} 
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="hidden sm:block">
          <CarouselPrevious />
          <CarouselNext />
        </div>
      </Carousel>
    </div>
  );
};
